import { BackedApi } from "../../../../config/urls/Api";
import { DrillsDto } from "./dto/drills.dto";

interface ResponseDrills {
    data: DrillsDto | any;
    error: boolean;
    status: number;
}

export class DrillsRepository {
    static async list(): Promise<ResponseDrills> {    
        const response = await this.sendRequest(
            BackedApi.ListDrills.url,
            BackedApi.ListDrills.method,            
        )
        const data = await response.json();
        const status = response.status;
        return { data, error: status !== 200, status };
    }

    private static async sendRequest(url: string, method: string, body?: any) {
        const response = await fetch(url, {
            method,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            ...(body && { body: JSON.stringify(body) }),            
        })
        return response;
    }
}
